// src/Components/EditNameModal.jsx
// "What should everyone call you?" Mirrors the mobile app's EditNameModal:
// one place to set the name used in every room and on the leaderboard.
import React, { useEffect, useState } from "react";
import BottomSheet from "./BottomSheet";
import useProfileStore from "../stores/profileStore";
import { MAX_DISPLAY_NAME_LENGTH } from "../utils/validateDisplayName";

const EditNameModal = ({ isOpen, onClose, onSaved }) => {
  const { displayName, saveDisplayName } = useProfileStore();
  const [value, setValue] = useState(displayName);
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setValue(displayName);
      setError("");
    }
  }, [isOpen]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError("");
    try {
      await saveDisplayName(value);
      onSaved?.(value.trim());
      onClose();
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <BottomSheet isOpen={isOpen} onClose={onClose} title="What should everyone call you?">
      <form onSubmit={handleSave} className="space-y-3">
        <label htmlFor="display-name" className="sr-only">Your name</label>
        <input
          id="display-name"
          type="text"
          autoFocus
          maxLength={MAX_DISPLAY_NAME_LENGTH}
          className="w-full border-2 border-gray-200 rounded-2xl py-4 px-5 text-lg text-center focus:ring-2 focus:ring-red-400 focus:border-red-400 outline-none transition-all placeholder:text-gray-500"
          placeholder="Your name"
          value={value}
          onChange={(e) => { setValue(e.target.value); setError(""); }}
          aria-invalid={!!error}
          aria-describedby="display-name-help"
        />
        {error ? (
          <p id="display-name-help" role="alert" className="text-sm text-center text-red-700">{error}</p>
        ) : (
          <p id="display-name-help" className="text-xs text-center text-brand-textSecondary">
            Shown to other players in rooms and on the leaderboard.
          </p>
        )}
        <button
          type="submit"
          disabled={saving || !value.trim()}
          className="btn-press w-full py-3.5 rounded-2xl font-bold text-lg text-white bg-brand-accent hover:bg-red-700 disabled:bg-gray-300 disabled:text-gray-600 disabled:cursor-not-allowed"
        >
          {saving ? "Saving…" : "Save name"}
        </button>
      </form>
    </BottomSheet>
  );
};

export default EditNameModal;
